<div class="password-field">
  <glxy-form-field>
    <input
      #password
      type="password"
      [disabled]="disabled"
      [ngModel]="value"
      [placeholder]="placeholder"
      matInput
      (ngModelChange)="onChange($event)"
      [required]="required"
    />
    <button
      glxySuffix
      mat-icon-button
      (click)="password.type === 'password' ? (password.type = 'text') : (password.type = 'password')"
    >
      <mat-icon>{{ password.type === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
    </button>
  </glxy-form-field>
  <button
    *ngIf="password.value"
    color="primary"
    mat-flat-button
    [cdkCopyToClipboard]="password.value"
    (cdkCopyToClipboardCopied)="notifyCopy()"
  >
    <b> {{ 'CONFIG_PAGE.COPY' | translate }}</b>
  </button>
</div>
